import { AvatarSource } from 'graphql/generated/scheme'

interface AvatarUser {
	avatarUrl?: string | null
	avatarSource?: AvatarSource | null
	instagramAvatarUrl?: string | null
}

export function resolveAvatarSrc(user?: AvatarUser | null): string | null | undefined {
	if (user?.avatarSource === AvatarSource.Instagram && user.instagramAvatarUrl) {
		return user.instagramAvatarUrl
	}
	return user?.avatarUrl
}

